import { render } from "./ReferenceForm.vue?vue&type=template&id=1deafbfa"
import script from "./ReferenceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/reference/ReferenceForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1deafbfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1deafbfa', __exports__)) {
    api.reload('1deafbfa', __exports__)
  }
  
  module.hot.accept("./ReferenceForm.vue?vue&type=template&id=1deafbfa", () => {
    api.rerender('1deafbfa', render)
  })

}


export default __exports__